import type { SVGProps } from "react";
import * as React from "react";

const SvgCrosshair = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18 11a1 1 0 1 0 0 2zM6 13a1 1 0 1 0 0-2zm5-7a1 1 0 1 0 2 0zm2 12a1 1 0 1 0-2 0zm8-6a9 9 0 0 1-9 9v2c6.075 0 11-4.925 11-11zm-9 9a9 9 0 0 1-9-9H1c0 6.075 4.925 11 11 11zm-9-9a9 9 0 0 1 9-9V1C5.925 1 1 5.925 1 12zm9-9a9 9 0 0 1 9 9h2c0-6.075-4.925-11-11-11zm10 8h-4v2h4zM6 11H2v2h4zm7-5V2h-2v4zm0 16v-4h-2v4z"
    />
  </svg>
);
export default SvgCrosshair;
